import { useThemeStore } from '@/lib/theme.store';
import { THEMES } from '@/lib/themes';

/**
 * ThemePicker — Vordefinierte Themes auswählen
 *
 * Kann in den Mandanten-Einstellungen oder im Profil eingebettet werden.
 * Zeigt für jedes Theme eine farbige Vorschaukarte.
 */
export function ThemePicker() {
  const { activeThemeId, setTheme } = useThemeStore();

  return (
    <div className="space-y-3">
      <p className="text-sm font-medium text-foreground">Erscheinungsbild</p>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        {Object.values(THEMES).map((theme) => {
          const isActive = theme.id === activeThemeId;
          return (
            <button
              key={theme.id}
              onClick={() => setTheme(theme.id)}
              className="group relative flex flex-col overflow-hidden rounded-lg border-2 transition-all hover:scale-[1.02]"
              style={{
                borderColor: isActive ? 'var(--primary)' : 'var(--border)',
              }}
              title={theme.name}
            >
              {/* Vorschau */}
              <div
                className="h-16 w-full"
                style={{ backgroundColor: `hsl(${theme.background})` }}
              >
                {/* Mini-Sidebar */}
                <div
                  className="h-full w-1/3 float-left"
                  style={{ backgroundColor: theme.sidebarBg }}
                />
                {/* Mini-Cards */}
                <div className="float-left ml-1 mt-2 space-y-1 w-1/2">
                  <div
                    className="h-2 rounded-sm"
                    style={{ backgroundColor: `hsl(${theme.primary})`, opacity: 0.7 }}
                  />
                  <div
                    className="h-1.5 w-3/4 rounded-sm"
                    style={{ backgroundColor: `hsl(${theme.muted})` }}
                  />
                  <div
                    className="h-1.5 w-1/2 rounded-sm"
                    style={{ backgroundColor: `hsl(${theme.muted})` }}
                  />
                </div>
              </div>

              {/* Label */}
              <div
                className="px-2 py-1.5 text-center"
                style={{
                  backgroundColor: `hsl(${theme.card})`,
                  color: `hsl(${theme.foreground})`,
                }}
              >
                <span className="text-xs font-medium">{theme.name}</span>
                {isActive && (
                  <span
                    className="ml-1 text-xs"
                    style={{ color: `hsl(${theme.primary})` }}
                  >
                    ✓
                  </span>
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
